import { render, staticRenderFns } from "./create-loading.vue?vue&type=template&id=778db082&scoped=true&"
import script from "./create-loading.vue?vue&type=script&lang=js&"
export * from "./create-loading.vue?vue&type=script&lang=js&"
import style0 from "./create-loading.vue?vue&type=style&index=0&id=778db082&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778db082",
  null
  
)

export default component.exports